import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-665e12f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, "Select Tableau Data", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Select a view:", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Select an underlying table:", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, "Select the target Google Sheet", -1 /* HOISTED */))
const _hoisted_6 = {
  key: 2,
  class: "authed double"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Logged in as: ", -1 /* HOISTED */))
const _hoisted_8 = { class: "email" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Select an existing sheet:", -1 /* HOISTED */))
const _hoisted_10 = {
  key: 6,
  class: "desc double"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "https://drive.google.com/drive/folders/", -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "15a8RxFsl6kBJeL3Xo76KNRIzOI83l9de", -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc double" }, " The data will be overwritten if already exists ", -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "last" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["TableauPopup"], {
    ref: "popup",
    width: 460,
    title: "Google Sheet Export",
    submitText: "Export Data",
    status: $setup.status,
    statusMessage: $setup.statusMessage,
    canSubmit: $setup.formValid,
    onSubmitted: $setup.doExport
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createVNode($setup["TableauSelect"], {
          placeholder: "View",
          getItems: $setup.getViews,
          modelValue: $setup.selectedViewId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedViewId) = $event))
        }, null, 8 /* PROPS */, ["modelValue"]),
        _createVNode($setup["TableauRadioButton"], {
          groupName: "data-type",
          value: "summary",
          modelValue: $setup.dataType,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.dataType) = $event)),
          text: "Summary Data"
        }, null, 8 /* PROPS */, ["modelValue"]),
        _createVNode($setup["TableauRadioButton"], {
          groupName: "data-type",
          value: "underlying",
          modelValue: $setup.dataType,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.dataType) = $event)),
          text: "Underlying Data"
        }, null, 8 /* PROPS */, ["modelValue"]),
        ($setup.dataType === 'underlying')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_4,
              _createVNode($setup["TableauSelect"], {
                ref: "underlyingSelector",
                placeholder: "Underlying table",
                getItems: $setup.getUnderlyingTables,
                modelValue: $setup.underlyingTableId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.underlyingTableId) = $event))
              }, null, 8 /* PROPS */, ["modelValue"])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        _createVNode($setup["TableauSeparator"], { class: "double" }),
        _hoisted_5,
        ($setup.googleAuthStatus !== 'authed')
          ? (_openBlock(), _createBlock($setup["TableauButton"], {
              key: 1,
              class: "double",
              style: {"max-width":"fit-content"},
              text: "Authenticate with Google",
              iconSvg: $setup.googleIconSvg,
              onClicked: _cache[4] || (_cache[4] = ($event: any) => ($setup.googleLogin())),
              isLoading: $setup.googleAuthStatus === 'loading',
              color: "secondary"
            }, null, 8 /* PROPS */, ["isLoading"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, _toDisplayString($setup.googleEmail), 1 /* TEXT */)
              ]),
              _createVNode($setup["TableauButton"], {
                text: "Logout",
                onClicked: _cache[5] || (_cache[5] = ($event: any) => ($setup.logoutGoogle())),
                color: "secondary"
              })
            ])),
        _createVNode($setup["TableauRadioButton"], {
          groupName: "sheet-mode",
          value: "create",
          modelValue: $setup.sheetMode,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.sheetMode) = $event)),
          text: "Create a new Spreadsheet"
        }, null, 8 /* PROPS */, ["modelValue"]),
        _createVNode($setup["TableauRadioButton"], {
          groupName: "sheet-mode",
          value: "update",
          modelValue: $setup.sheetMode,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.sheetMode) = $event)),
          text: "Update an existing Spreadsheet"
        }, null, 8 /* PROPS */, ["modelValue"]),
        ($setup.sheetMode === 'create')
          ? (_openBlock(), _createBlock($setup["TableauTextBox"], {
              key: 3,
              modelValue: $setup.newSheetName,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.newSheetName) = $event)),
              label: "New Speadsheet Name",
              placeholder: "Spreadsheet Name"
            }, null, 8 /* PROPS */, ["modelValue"]))
          : _createCommentVNode("v-if", true),
        ($setup.sheetMode === 'update')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _hoisted_9,
              _createVNode($setup["TableauSelect"], {
                ref: "existingSheetsSelector",
                placeholder: "Sheet Name",
                getItems: $setup.loadExistingSheets,
                modelValue: $setup.selectedExistingSheetId,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.selectedExistingSheetId) = $event))
              }, null, 8 /* PROPS */, ["modelValue"])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        ($setup.sheetMode === 'create')
          ? (_openBlock(), _createBlock($setup["TableauTextBox"], {
              key: 5,
              modelValue: $setup.sheetFolderId,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.sheetFolderId) = $event)),
              label: "Folder ID (optional)",
              placeholder: "Folder ID"
            }, null, 8 /* PROPS */, ["modelValue"]))
          : _createCommentVNode("v-if", true),
        ($setup.sheetMode === 'create')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createTextVNode(" As it appears in the URL, such as: "),
              _hoisted_11,
              _hoisted_12
            ]))
          : _createCommentVNode("v-if", true),
        _createVNode($setup["TableauTextBox"], {
          modelValue: $setup.targetSheetName,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.targetSheetName) = $event)),
          label: "Target sheet",
          placeholder: "Sheet Name"
        }, null, 8 /* PROPS */, ["modelValue"]),
        _hoisted_13,
        _hoisted_14
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["status", "statusMessage", "canSubmit"]))
}